module.exports = __webpack_public_path__ + "img/b-medal-silver.294d224d.png";